<template>
  <!-- <div id="app" :key="key"> -->
  <div id="main-wrapper" :key="key">
    <default-theme v-if="theme === 'default'">
      <router-view :key="$route.fullPath" />
    </default-theme>
    <auth-theme v-if="theme === 'auth'">
      <router-view :key="$route.fullPath" />
    </auth-theme>
    <toast position="se"></toast>
  </div>
</template>

<script>
import { Toast } from "vuex-toast";

import DefaultTheme from "@/themes/Default";
import AuthTheme from "@/themes/Auth";

import helper from "@/libs/helper";

import "vuex-toast/dist/vuex-toast.css";
import "vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css";
import "vue-image-lightbox/dist/vue-image-lightbox.min.css";
import 'element-ui/lib/theme-chalk/index.css';

export default {
  name: "App",
  components: {
    DefaultTheme,
    AuthTheme,
    Toast
  },
  computed: {
    theme() {
      return this.$store.state.route.meta.theme;
    },
    key() {
      return this.$route.fullPath;
    }
  },
  watch: {
    key: function() {
      helper.scrollTop();
    }
  },
  mounted: function() {
    // document.querySelector('.preloader').style.display = 'none';
  }
};
</script>

<style>
@import "./assets/css/style.css";
@import "./assets/css/pages/form-icheck.css";
@import "./assets/css/pages/tab-page.css";
@import "./assets/css/custom.css";
@import "./assets/css/pages/vue-datetime.css";
@import "./assets/libs/datatables/datatables.min.css";
@import "./assets/css/pages/stylish-tooltip.css";
</style>
